import { BRAND_SHADES, brandShades, DEFAULT_BRAND_COLOR } from '@tekansa/core/branding';
import { useEffect } from 'react';

/**
 * Step 17c: the organisation's brand colour themes the whole app. Every brand shade (the
 * Tailwind `brand-*` colours, and through them the primary colour, focus rings and the selected
 * menu item) is set on <html> from the one colour; light and dark mode both follow. Tekansa blue
 * when there is none.
 */
export function useBrandTheme(color: string | null | undefined): void {
  useEffect(() => {
    if (!color || color.toLowerCase() === DEFAULT_BRAND_COLOR) return;
    const root = document.documentElement;
    for (const [shade, value] of Object.entries(brandShades(color)))
      root.style.setProperty(`--color-brand-${shade}`, value);
    return () => {
      for (const shade of BRAND_SHADES) root.style.removeProperty(`--color-brand-${shade}`);
    };
  }, [color]);
}
